import { render } from "./CalendarDemo.vue?vue&type=template&id=0a3a6f75&scoped=true"
import script from "./CalendarDemo.vue?vue&type=script&lang=js"
export * from "./CalendarDemo.vue?vue&type=script&lang=js"

import "./CalendarDemo.vue?vue&type=style&index=0&id=0a3a6f75&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3a6f75"]])

export default __exports__